import { cn } from '@/lib/utils';

type HeaderOverlayProps = {
    open: boolean;
    onClose: () => void;
    className?: string;
};

/**
 * Shared backdrop for header panels that are not backed by a modal primitive.
 * Mounts only while open (no enter/exit animation — avoids flash on desktop menu hover).
 * Starts below the sticky header/ticker so triggers remain usable.
 *
 * Used for search (mobile + desktop) and desktop mega-menu. Mobile nav Sheet already
 * owns a full-screen overlay — do not use this there.
 */
export function HeaderOverlay({ open, onClose, className }: HeaderOverlayProps) {
    if (!open) {
        return null;
    }

    return (
        <div
            data-slot="header-overlay"
            aria-hidden="true"
            className={cn(
                'fixed inset-x-0 bottom-0 top-[calc(var(--ticker-height,0px)+var(--header-height,0px))] z-50 bg-black/50',
                className
            )}
            onPointerDown={onClose}
        />
    );
}
